import angular from "angular";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { vsName as conversionModalComponentOptionsName } from "./component";

export const vsServiceName = "conversionModalService";

export interface ConversionModalOptions {}

export class ConversionModalService {
  static $inject = ["$uibModal", ServerUtilityName];
  constructor(
    private readonly $uibModal: angular.ui.bootstrap.IModalService,
    private readonly serverUtility: ServerUtility
  ) {}

  openModal(config?: ConversionModalOptions) {
    return this.$uibModal.open({
      component: conversionModalComponentOptionsName,
      resolve: {
        config: () => config,
      },
    });
  }
}
